import { useState, useEffect } from 'react';
import { WifiOff, Wifi, RefreshCw } from 'lucide-react';
import { ds } from '../../../design-system/tokens';

export function NetworkStatus() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [showReconnected, setShowReconnected] = useState(false);
  const [wasOffline, setWasOffline] = useState(false);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      if (wasOffline) {
        setShowReconnected(true);
        setTimeout(() => setShowReconnected(false), 3000);
      }
    };

    const handleOffline = () => {
      setIsOnline(false);
      setWasOffline(true);
      setShowReconnected(false);
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, [wasOffline]);

  if (isOnline && !showReconnected) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-[9999] transition-all duration-300 ease-in-out">
      {!isOnline && (
        <div
          className="px-4 py-2.5 shadow-sm"
          style={{ backgroundColor: ds.color.raw.systemOrange + '14', borderBottom: `1px solid ${ds.color.raw.systemOrange}30` }}
        >
          <div className="max-w-7xl mx-auto flex items-center justify-center gap-3">
            <WifiOff className="w-4 h-4" style={{ color: ds.color.raw.systemOrange }} />
            <span className={`${ds.type.footnote} ${ds.type.weight.medium}`} style={{ color: ds.color.raw.systemOrange }}>
              You're offline
            </span>
            <span className={`hidden sm:inline ${ds.type.caption1}`} style={{ color: ds.color.raw.systemGray }}>
              Some features may be unavailable until you reconnect
            </span>
            <button
              onClick={() => window.location.reload()}
              className={`ml-1 flex items-center gap-1.5 px-3 py-1 ${ds.radius.full} ${ds.type.caption1} ${ds.type.weight.semibold} ${ds.transition.fast}`}
              style={{
                color: ds.color.raw.systemOrange,
                backgroundColor: ds.color.raw.systemOrange + '14',
              }}
              onMouseEnter={e => { e.currentTarget.style.backgroundColor = ds.color.raw.systemOrange + '28'; }}
              onMouseLeave={e => { e.currentTarget.style.backgroundColor = ds.color.raw.systemOrange + '14'; }}
            >
              <RefreshCw className="w-3 h-3" />
              <span className="hidden sm:inline">Retry</span>
            </button>
          </div>
        </div>
      )}

      {isOnline && showReconnected && (
        <div
          className="px-4 py-2.5 shadow-sm"
          style={{ backgroundColor: ds.color.raw.systemGreen + '14', borderBottom: `1px solid ${ds.color.raw.systemGreen}30` }}
        >
          <div className="max-w-7xl mx-auto flex items-center justify-center gap-3">
            <Wifi className="w-4 h-4" style={{ color: ds.color.raw.systemGreen }} />
            <span className={`${ds.type.footnote} ${ds.type.weight.medium}`} style={{ color: ds.color.raw.systemGreen }}>
              You're back online
            </span>
          </div>
        </div>
      )}
    </div>
  );
}
